import { ControllerFieldState, FieldValues, RegisterOptions, UseFormStateReturn } from 'react-hook-form';
import { useTextReturn } from '../../../utils/hooks/use_text';

export interface InputInFormProps {
	optional?: boolean;
	required?: boolean;
	readOnly?: boolean;
	invalid?: boolean;
	invalidText?: string;
	options?: RegisterOptions;
}

export class InputPropsHelper {
	private readonly props: InputInFormProps;
	private readonly staticTexts: useTextReturn | null;
	private readonly fieldState: ControllerFieldState;
	private readonly formState: UseFormStateReturn<FieldValues>;

	constructor(
		props: InputInFormProps,
		staticTexts: useTextReturn | null,
		fieldState: ControllerFieldState,
		formState: UseFormStateReturn<FieldValues>,
	) {
		this.props = props;
		this.staticTexts = staticTexts;
		this.fieldState = fieldState;
		this.formState = formState;
	}

	public isOptional(): boolean {
		return this.props.optional ?? (!this.props.options?.required || false);
	}
	public isRequired(): boolean {
		return this.props.required ?? (!!this.props.options?.required || false);
	}
	public isReadOnly(): boolean {
		return this.props.readOnly ?? (this.formState.isValid && this.formState.isSubmitting ? true : false);
	}
	public isInvalid(): boolean {
		return this.props.invalid ?? (this.fieldState.invalid || false);
	}
	public invalidText(): string {
		return (
			this.props.invalidText ??
			(this.fieldState.error?.message || this.staticTexts?.('Component.Form.GeneralInputError') || 'Unknown error')
		);
	}
}
